const east_coast_mtns = [
  {
    title: 'Killington',
    location: 'VT | USA',
    rating: '3.5 ★',
  },
  {
    title: 'Sunday River',
    location: 'ME | USA',
    rating: '3.5 ★',
  },

  {
    title: 'Sugarbush',
    location: 'VT | USA',
    rating: '3 ★',
  },
  {
    title: 'Loon',
    location: 'NH | USA',
    rating: '1 ★',
  },
  {
    title: 'Stratton',
    location: 'VT | USA',
    rating: '1 ★',
  },
];

const west_coast_mtns = [
  {
    title: 'Snowbasin',
    location: 'UT | USA',
    rating: '5 ★',
  },
  {
    title: 'Snowbird',
    location: 'UT | USA',
    rating: '5 ★',
  },
  {
    title: 'Deer Valley',
    location: 'UT | USA',
    rating: '4 ★',
  },
  {
    title: 'Palisades Tahoe',
    location: 'CA | USA',
    rating: '4 ★',
  },
  {
    title: 'Mt. Bachelor',
    location: 'OR | USA',
    rating: '4 ★',
  },
  {
    title: 'Brighton',
    location: 'UT | USA',
    rating: '3.5 ★',
  },
  {
    title: 'Crystal Mountain',
    location: 'WA | USA',
    rating: '3.5 ★',
  },
  {
    title: 'Steamboat',
    location: 'CO | USA',
    rating: '3.5 ★',
  },
  {
    title: 'Copper Mountain',
    location: 'CO| USA',
    rating: '3 ★',
  },
  {
    title: 'Arapahoe Basin',
    location: 'CO| USA',
    rating: '3 ★',
  },
  {
    title: 'Solitude',
    location: 'UT | USA',
    rating: '3 ★',
  },
];

const eu_mtns = [
  {
    title: 'Chamonix Mont-Blanc',
    location: 'FR',
    rating: '3.5 ★',
  },

  {
    title: 'Sölden',
    location: 'AT',
    rating: '3 ★',
  },


];

const sa_mtns = [
  {
    title: 'Valle Nevado',
    location: 'CL',
    rating: '3.5 ★',
  },

  {
    title: 'La Parva',
    location: 'CL',
    rating: '3 ★',
  },

];

export default { east_coast_mtns, west_coast_mtns, eu_mtns, sa_mtns};
